import { render, staticRenderFns } from "./SwiperContainer.vue?vue&type=template&id=ba213346&"
import script from "./SwiperContainer.vue?vue&type=script&lang=js&"
export * from "./SwiperContainer.vue?vue&type=script&lang=js&"
import style0 from "./SwiperContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba213346')) {
      api.createRecord('ba213346', component.options)
    } else {
      api.reload('ba213346', component.options)
    }
    module.hot.accept("./SwiperContainer.vue?vue&type=template&id=ba213346&", function () {
      api.rerender('ba213346', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/components/vue/swiper/SwiperContainer.vue"
export default component.exports